import React from 'react'
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
import { useTicket } from '../../Hook/App'
import Spinner from '../../Components/Spinner'
function Ticket() {
    const { ticket, loading, send, onChange, user } = useTicket();

    return (
        <Layout>
            <HeaderMain lable="ارتباط با پیشتیبانی" />
            <div className="all-support" style={{ paddingTop: '4rem' }}>
                <div className='messages px-2'>
                    {ticket && ticket.messages && ticket.messages.map((message, i) => {
                        let classN = user.id == message.user_id ? "" : "answer";
                        return (
                            <div className={`message ${classN}`}>
                                <div className='d-flex align-items-center'>
                                    <small>{user.id == message.user_id ? "شما" : "پاسخ"}</small>
                                </div>
                                <p>{message.message}</p>
                            </div>
                        )
                    })}
                </div>
            </div>
            {ticket && ticket.status == 'close' ? null : <div className='sendMessage col-lg-4'>
                <input type="text" name='text' placeholder='پیام خود را اینجا بنویسید ...' onChange={onChange} />
                <button className='btn' disabled={loading.send} onClick={send}>{loading.send ? <Spinner sm /> : <i className='far fa-arrow-left'></i>}</button>
            </div>}
        </Layout>
    )
}

export default Ticket